import { TAvailableConfigValues } from '@customTypes/common';

export interface ITargetBufferIncreaserConfig {
  bufferAmountToIncrease: number;
  bufferAmountThreshold: number;
}

export const defaultTargetBufferIncreaserConfig: ITargetBufferIncreaserConfig = {
  bufferAmountToIncrease: 200,
  bufferAmountThreshold: 300,
};

export const availableTargetBufferIncreaserConfigValues: TAvailableConfigValues<ITargetBufferIncreaserConfig> = {};
